import 'core-js';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import store from './store';
import {library} from '@fortawesome/fontawesome-svg-core';

import {faExclamationTriangle, faFileCsv, faHome, faList, faExternalLinkAlt, faPencilAlt, faSave,
    faPlus, faMinus, faAngleUp, faExchangeAlt, faFlagCheckered, faSignInAlt, faSignOutAlt, faFilter, faClone, faRedo, faQuestionCircle, faPrint,
    faBackspace, faFileDownload, faBold, faItalic, faUnderline, faQrcode, faUsersCog, faLink, faAlignLeft, faAlignCenter, faAlignRight,
    faPercent, faMapMarkedAlt, faSpinner, faCircleNotch, faCog, faStar, faExpand, faCompress}
    from '@fortawesome/free-solid-svg-icons';
import {faCopy, faFileExcel, faFilePdf, faObjectGroup, faImage}
    from '@fortawesome/free-regular-svg-icons';
library.add(faExclamationTriangle, faFileCsv, faHome, faList, faExternalLinkAlt, faPencilAlt, faSave,
    faPlus, faMinus, faAngleUp, faExchangeAlt, faFlagCheckered, faSignInAlt, faSignOutAlt, faFilter, faClone, faRedo, faQuestionCircle,
    faPrint, faBackspace, faFileDownload, faBold, faItalic, faUnderline, faQrcode, faUsersCog, faLink, faAlignLeft, faAlignCenter,
    faAlignRight, faCopy, faFileExcel, faFilePdf,
    faObjectGroup, faImage, faPercent, faMapMarkedAlt, faSpinner, faCircleNotch, faCog, faStar, faExpand, faCompress);

import '../styles/style.scss';

const render = () => {
    ReactDOM.render(
        <App store={store} />,
        document.getElementById('app-root'),
    );
};

render();

if (module.hot) {
    module.hot.accept(render);
}
